<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">Serviços</span>
        <h3 class="page-title d-inline">Editar</h3>
        <d-link class="btn btn-success text-white float-right" :to="{ name: 'admin-service-new' }">Novo serviço</d-link>
        <d-button type="button" @click.prevent="save" class="btn-accent float-right mr-2">Salvar</d-button>
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row>
      <d-col lg="12">
        <service-page :service="service" ref="serviceForm"/>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import ServicePage from '_modules/service/components/ServicePage.vue';
import { MODEL, _LOAD_MODEL_ } from '../components/ServiceModel';

export default {
  name: 'service-edit',
  components: {
    ServicePage,
  },
  computed: {
    service() {
      const { service } = this.$store.state.service;
      if (service) {
        Events.$emit(_LOAD_MODEL_, service);
        return service;
      }
      return MODEL;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getService',
    ]),
    getServiceModel() {
      this.getService(parseInt(this.$route.params.serviceId, Number));
    },
    save() {
      this.$refs.serviceForm.save();
    },
  },
  mounted() {
    if (this.$route.params.serviceId) {
      this.getServiceModel();
    }
  },
};
</script>

